exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-portals-menu{display:flex;flex-direction:column;min-width:180px}.fts-portals-menu>button{border:none;background:transparent;font-family:inherit;text-align:left;cursor:pointer}.fts-portals-menu>button:focus-visible{outline:2px solid var(--fts-primary,currentColor);outline-offset:-2px}.fts-portals-menu>.fts-portals-menu-danger{color:var(--fts-danger,#d32f2f)}", ""]);

// exports
